<template>
	<div class="padding-lg" v-loading="loadingPage">
		<div class="text-xxl">{{ $route.meta.title }}</div>
		<div class="padding-top-xl">
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<span class="el-icon-search"></span>
					<span class="text-bold margin-left-sm">信息检索</span>
				</div>
				<el-form :inline="true" :model="formSearch" class="demo-form-inline">
					<el-form-item label="登陆账号"><el-input v-model="formSearch.data.username" clearable placeholder="精确查找" style="width: 150px;"></el-input></el-form-item>
					<el-form-item label="状态">
						<el-select v-model="formSearch.data.state" clearable placeholder="状态" style="width: 120px;">
							<el-option label="全部" value=""></el-option>
							<el-option label="正常" value="1"></el-option>
							<el-option label="禁用" value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="昵称"><el-input v-model="formSearch.data.nickname" clearable placeholder="模糊搜索" style="width: 180px;"></el-input></el-form-item>
					<el-form-item label="手机号">
						<el-input v-model="formSearch.data.mobile" maxlength="11" clearable placeholder="精确查找" style="width: 150px;"></el-input>
					</el-form-item>
					<el-form-item label="注册来源">
						<el-select v-model="formSearch.data.source_type" clearable placeholder="注册来源" style="width: 120px;">
							<el-option label="全部" value=""></el-option>
							<el-option label="小程序" value="xcx"></el-option>
							<el-option label="管理员" value="manager"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="注册时间">
						<el-date-picker
							v-model="formSearch.data.addtime"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item><el-button type="primary" @click="loadinfos">查询</el-button></el-form-item>
				</el-form>
			</el-card>
			<el-card class="box-card margin-top" :body-style="{ padding: '0px' }">
				<el-table
					:data="tableData"
					style="width: 100%"
					stripe
					v-loading="loading"
					element-loading-text="加载中..."
					element-loading-spinner="el-icon-loading"
				>
					<el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
					<el-table-column align="center" label="头像" width="180">
						<template slot-scope="scope">
							<el-avatar :size="64" :src="scope.row.avatar"></el-avatar>
						</template>
					</el-table-column>
					<el-table-column align="center" label="客户名称">
						<template slot-scope="scope">
							<div class="text-blue text-bold text-left">{{ scope.row.name }}</div>
							<div class="text-grey text-left">{{ scope.row.name_en }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="position" align="center" label="职务" width="220"></el-table-column>
					<el-table-column prop="mobile" align="center" label="手机" width="220"></el-table-column>
					<el-table-column prop="type" align="center" label="类型" width="120">
						<template slot-scope="scope">
							<span v-if="scope.row.type == '公司'" class="cu-tag bg-blue radius">公司</span>
							<span v-else-if="scope.row.type == '个体'" class="cu-tag bg-cyan radius">个体</span>
							<span v-else class="cu-tag bg-gray radius">其他</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label="业务" width="120">
						<template slot-scope="scope">
							<el-popover placement="top" trigger="click" v-if="scope.row.salesman">
								<div class="">
									<div class="infoshow-line">
										<div class="title">姓名：</div>
										<div class="con">{{ scope.row.salesman.name }}</div>
									</div>
									<div class="infoshow-line">
										<div class="title">状态：</div>
										<div class="con">
											<span v-if="scope.row.salesman.stateflag" class="cu-tag round bg-green sm">在职</span>
											<span v-else class="cu-tag round bg-gray sm">离职</span>
										</div>
									</div>
									<div class="infoshow-line">
										<div class="title">工号：</div>
										<div class="con">{{ scope.row.salesman.officeid }}</div>
									</div>
									<div class="infoshow-line">
										<div class="title">职务：</div>
										<div class="con">{{ scope.row.salesman.position }}</div>
									</div>
								</div>
								<span slot="reference">{{ scope.row.salesman.name }}</span>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column align="center" label="客服" width="120">
						<template slot-scope="scope">
							<el-popover placement="top" trigger="click" v-if="scope.row.service">
								<div class="">
									<div class="infoshow-line">
										<div class="title">姓名：</div>
										<div class="con">{{ scope.row.service.name }}</div>
									</div>
									<div class="infoshow-line">
										<div class="title">状态：</div>
										<div class="con">
											<span v-if="scope.row.service.stateflag" class="cu-tag round bg-green sm">在职</span>
											<span v-else class="cu-tag round bg-gray sm">离职</span>
										</div>
									</div>
									<div class="infoshow-line">
										<div class="title">工号：</div>
										<div class="con">{{ scope.row.service.officeid }}</div>
									</div>
									<div class="infoshow-line">
										<div class="title">职务：</div>
										<div class="con">{{ scope.row.service.position }}</div>
									</div>
								</div>
								<span slot="reference">{{ scope.row.service.name }}</span>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="addtime" align="center" label="创建时间" width="180"></el-table-column>
					<el-table-column align="center" label="操作" width="120">
						<template slot-scope="scope">
							<router-link :to="'/order/view/' + scope.row.orderid"><el-button size="small" type="primary">查看</el-button></router-link>
						</template>
					</el-table-column>
				</el-table>
				<div class="padding text-right">
					<el-pagination
						background
						@size-change="pageSizeChange"
						@current-change="pageChange"
						:current-page="formSearch.page"
						:page-sizes="[10, 20, 50, 100]"
						:page-size="20"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</div>
			</el-card>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loadingPage: false,
			infos_agent: [],
			infos_state: [],
			formSearch: {
				page: 1,
				size: 20,
				data: {}
			},
			total: 0,
			loading: false,
			tableData: []
		};
	},
	beforecreate: function() {},
	created: function() {
		this.loadingPage = true;
		this.$http.post('/server/index.php?m=hr/employee/list&a=init', this.formSearch).then(
			res => {
				this.loadingPage = false;
				if (typeof res.data != 'object') {
					this.$alert(res.data ? res.data : '(无返回数据)', {
						title: '返回数据格式错误',
						type: 'error'
					});
				} else {
					if (res.data.result == 'ok') {
						this.infos_agent = res.data.data.infos_agent;
						this.infos_state = res.data.data.infos_state;
						this.loadinfos();
					} else {
						this.$alert(res.data.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				}
			},
			r => {
				this.loadingPage = false;
				this.$alert('网络错误，指定的服务无法访问。', {
					title: '系统错误',
					type: 'error'
				});
			}
		);
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		loadinfos() {
			var that = this;
			this.loading = true;
			this.$http.post('/server/index.php?m=hr/employee/list&a=list', this.formSearch).then(
				res => {
					this.loading = false;
					if (typeof res.data != 'object') {
						this.$alert(res.data ? res.data : '(无返回数据)', {
							title: '返回数据格式错误',
							type: 'error'
						});
					} else {
						if (res.data.result == 'ok') {
							this.total = res.data.data.total;
							this.tableData = res.data.data.infos;
						} else {
							this.$alert(res.data.msg, {
								title: '操作错误',
								type: 'error'
							});
						}
					}
				},
				r => {
					this.loading = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		pageChange(page) {
			this.formSearch.page = page;
			this.loadinfos();
		},
		pageSizeChange(size) {
			this.formSearch.size = size;
			this.loadinfos();
		}
	}
};
</script>

<style></style>
